import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/usr/src/app/www/src/templates/default-mdx-layout.js";
import { SignupForm } from "../components/signupForm";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`MDX file without a default export`}</h2>
    <p>{`This page does not use a default export, so it will take on the default layout set by the gatsby-config file.`}</p>
    <p><img parentName="p" {...{
        "src": "https://res.cloudinary.com/kathleenmcmahon/image/upload/v1587501269/100-days-of-gatsby-cloudinary/castaway-key-umbrellas-closeup.jpg",
        "alt": "Colorful group of umbrellas nestled on the soft tropical sands of Castaway Cay"
      }}></img></p>
    <iframe title="Ya Ya eating Banana" width="560" height="315" src="https://www.youtube.com/embed/4SZl1r2O_bY" frameBorder="0" allowFullScreen></iframe>
    <h3>{`Where do I start with this nested file?`}</h3>
    <p>{`The documentation offers guides for all different skill levels, you can
find more info at the Gatsby's `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/docs/quick-start"
      }}>{`Quick Start page`}</a></p>
    {
      /* This default export overrides the default layout set in the
      gasby-config.js file ensuring that the FAQ component isn't wrapped
      by other elements */
    }
    <SignupForm mdxType="SignupForm" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      